// extracted by mini-css-extract-plugin
export var offlineNotificaton = "fh_KD";
export var offlineNotificaton__button = "fh_KH";
export var offlineNotificaton__header = "fh_KG";
export var offlineNotificaton__text = "fh_KJ";
export var offlineNotificaton__withCookie = "fh_KF";